import React from 'react';


export let AppContext = React.createContext({
    config: {dockedMenu: false, theme: 'light'},
    toggleMenu: () => {},
    togglePopup: (icon = null, content = null, title = null) => {},
    toggleModal: (icon = null, content = null, title = null) => {},
    toggleMessageBox: (title = null, content = null, type = null) => {},
    toggleToast: (icon, message, isError = false) => {}
})